export default {
  home: 'Home',
  FAQs: 'FAQs',
  register: 'Register',
  contactUs: 'Contact Us',
  signIn: 'Sign In',
  languageButton: 'Español',
  termsOfUse: 'Terms of Use',
  disclaimer: 'Disclaimer',
  noticeOfNonDiscrimination: 'Notice of Non-Discrimination',
  copyright: 'Copyright \u00A9 {year} MDLIVE Inc. All Rights Reserved.',
  displayTitle: 'Register for {affiliationName}.',
  displayTagline: 'A faster way to wellness.',
  displayInfo: 'Convenient, real visits with a {providerTypes} online.',
  providerTypes:
    'Board Certified Doctor, Behavioral Health Provider or Dermatologist',
  subtitle: 'Your information',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Your current email',
  username: 'Create your username',
  password: 'Create a password',
  passwordRequirement1: 'Use a password different from your username',
  passwordRequirement2: 'Must be between 8 and 20 characters',
  passwordRequirement3: 'Must have at least 1 uppercase letter',
  passwordRequirement4: 'Must have at least 1 lowercase letter',
  passwordRequirement5: 'Must have at least 1 special character',
  passwordRequirement6: 'Password is case-sensitive',
  showPassword: 'Show Password',
  alreadyMember: 'Already a member?',
  signInHere: 'Sign in here',
  nextButton: 'Next',
  dateOfBirth: 'Date of Birth',
  phoneNumber: 'Phone Number',
  zipCode: 'Zip Code',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  nonBinary: 'Non-binary',
  nonBinaryTooltip:
    'A non-binary person is someone who does not identify as only male or only female',
  receiveBenefitQuestion:
    'Do you receive {affiliationName} as a benefit through an employer, insurance provider or organization?',
  yesButton: 'Yes',
  noButton: 'No',
  agreeToTerms: 'I agree to the {termsLink} and {privacyLink}.',
  termsOfService: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  createAccount: 'Create Account',
  affiliationCoverageText:
    'MDLIVE has partnered with {affiliationCoverageName} to provide access to local providers where it is most convenient for you – home, office or on the go! You can have a virtual visit with a {affiliationCoverageName} provider via smartphone, tablet or computer for non-emergency medical issues 24/7/365.',
  affiliationCoverageCTAText:
    'Click Yes below to access doctors from {affiliationCoverageName} – One of the nation’s most trusted health systems.',
  benefitDisplayTitle: '{affiliationName} as a benefit.',
  oops: 'Oops!',
  'eligibilityError.Text1':
    'We apologize, but we cannot confirm your eligibility information at this time. Please contact your benefit administrator to verify your eligibility. You can also try to re-enter your information and verify again.',
  'eligibilityError.Text2':
    'If you select Continue below, MDLIVE will allow you to continue to register, but your credit card will be authorized for the full consult amount until we are able to verify your eligibility to adjust your final payment due accordingly.',
  'eligibilityError.Text3':
    'If you believe this an error, please contact our Customer Support team or you can also try to re-enter your information and verify again.',
  'eligibilityError.pleaseCall': 'Please Call',
  multipleBenefitProviders:
    'We found several possible Benefit Providers for you. Please select one to continue.',
  backButton: '{backArrow} Back',
  continueButton: 'Continue',
  getStarted: "Let's get started",
  benefitProviderSearch: 'Benefit Provider Search',
  benefitProviderTooltip: 'Type in more characters for better results.',
  businessUnit: 'Business Unit',
  insurancePlan: 'Insurance Plan',
  medicalInsuranceID: 'Medical Insurance ID',
  isInsuredAsDependent: 'Are you insured as a dependent?',
  signupButton: 'Signup',
  verifyButton: 'Verify',
  noMatchFound: 'No matches found',
  primaryPolicyHolder: 'Primary Policy Holder',
  primaryInsuranceID: 'Primary Insurance ID',
  relationshipToPolicyHolder: 'Relationship to Policy Holder',
  spouse: 'Spouse',
  child: 'Child',
  otherAdult: 'Other Adult',
  'validationError.differentUsername': 'should be different than username',
  'validationError.8to20characters': '8 to 20 characters',
  'validationError.min1number': 'at least one number',
  'validationError.requiredUppercase': 'at least one uppercase letter',
  'validationError.requiredLowercase': 'at least one lowercase letter',
  'validationError.requiredSpecialCharacter': 'at least 1 special character',
  'validationError.validEmail': 'Please use a valid e-mail',
  'validationError.usernameTaken': 'Username is taken',
  'validationError.6to30characters': '6 - 30 characters',
  'validationError.leastOneLetter': 'at least one letter',
  'validationError.noSpacesOrSpecialChars':
    'no spaces or special characters (&, %, *)',
  'validationError.invalidDate': 'Invalid Date',
  'validationError.phone10digits': 'Must only contain 10 digits',
  'validationError.phoneDigitsOnly': 'no dashes or parenthesis',
  'validationError.zipNumbersOnly': 'must only contain numbers',
  'validationError.zip5characters': 'Must be 5 characters',
  'validationError.required': 'Required',
};



// WEBPACK FOOTER //
// ./translations/en.js